<div class="absolute inset-0 bg-black opacity-50"></div>
<div
  [ngClass]="isWebview ? 'pt-6' : ''"
  class="absolute inset-0 z-30 flex-col justify-between overflow-y-hidden bg-white pb-[80px] md:m-10 md:flex md:overflow-y-auto md:rounded-3xl md:pb-4">
  <div class="h-full flex-col overflow-y-auto py-4 font-medium md:flex md:flex-1 md:py-10">
    <div class="flex items-center">
      <button
        app-icon-button
        name="x"
        size="md"
        (click)="closeModal.emit()"
        class="mx-4 md:ml-10 md:mr-5"
        type="button"></button>
      <h1 class="prose-display-lg" translate>{{ termAndConditions()?.title }}</h1>
    </div>
    <div class="p-4 md:px-10" *ngIf="termAndConditions()">
      <div
        class="include-links text-base"
        [innerHtml]="termAndConditions()!.content | safeHtml"></div>
    </div>
  </div>
</div>
